<template>
  <gj-modal
    :visible.sync="modalVisible"
    :destroyOnClose="true"
    size="custom"
    width="350px"
    cancel-text="取消"
    @cancel="cancel"
    @confirm="confirm"
    :confirm-loading="confirmLoading"
  >
    <template #header>分配负责人</template>
    <template #content>
      <el-form ref="form" :model="form" v-loading="contentLoading">
        <el-form-item
          prop="chargeIdList"
          label="销售负责人"
          label-width="90px"
          :rules="{ required: true, message: '请选择负责人', trigger: ['blur', 'change'] }"
        >
          <gj-select
            style="width: 213px"
            v-model="form.chargeIdList"
            type="multi-check"
            collapse-tags
            :options="chargerList"
          >
          </gj-select>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import { getChargerList, postAddCharger } from '@/api/sale';
import { getUserOptions } from '@/api/user';
import { modalMixIn } from '@/minxins';

export default {
  name: 'charge-distribution-modal',
  props: {
    ids: Array,
    commonQueryDTOS: Array,
  },
  mixins: [modalMixIn],
  data() {
    return {
      form: {
        chargeIdList: [],
      },
      chargerList: [],
      contentLoading: false,
    };
  },
  created() {
    this.getChargerList();
  },
  methods: {
    /**
     * 确认
     */
    confirm() {
      this.postAddCharger();
    },
    /**
     * 获取产品负责人列表
     */
    getChargerList() {
      let params = {
        listingId: this.ids || [],
      };
      const isMultiple = params.listingId.length > 1;
      this.contentLoading = true;
      getUserOptions('ENABLE').then((res = []) => {
        this.chargerList = res;
        if (!isMultiple) {
          getChargerList(params)
            .then((response) => {
              this.form.chargeIdList = response.map((v) => v.userId);
            })
            .complete(() => (this.contentLoading = false));
        } else {
          this.contentLoading = false;
        }
      });
    },
    /**
     * 添加产品负责人
     */
    postAddCharger() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          let params = {
            chargeIdList: this.form.chargeIdList,
            listingList: this.ids,
            ids: this.ids,
            commonQueryDTOS: this.commonQueryDTOS,
          };
          postAddCharger(params)
            .then(() => {
              this.$gjMessage.success('添加成功');
              this.$emit('confirm');
            })
            .complete(() => (this.confirmLoading = false));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
  padding-bottom: 0;
}
///deep/ .el-form-item{
//  margin-bottom: 0;
//}
</style>
